const agent = {
    path: 'agent/list',
    component: resolve => require(['../../../../../pages/admin/channel/agent/list'], resolve),
    meta: {
        requireAuth: true
    }
}

export default agent